import { useEffect, useState } from 'react';
import { fetchTags } from '../search/api/api-tags.js';
import { useAuthQuery } from '#lib/hooks/use-query.js';

export function useTags() {
    const { data, isLoading } = useAuthQuery({
        queryKey: ['tags'],
        queryFn: fetchTags,
        refetchOnWindowFocus: false
    });

    const [tags, setTags] = useState(data ?? []);
    useEffect(() => {
        if (data) setTags(data);
    }, [data]);
    const [selectedTags, selectTags] = useState([]);

    return {
        tags,
        isLoading,
        selectedTags,
        selectTags
    };
}
